import { RemitoEstado } from 'src/utils/enums/RemitoEstado';
import { RemitoFormState } from './types';
import { colorMapping } from 'src/utils/enums/RemitoEstado';
import { marcarEnviadoRemitoF, marcarRecepcionadoRemitoF } from './apiThunk';
import { RootState } from 'src/app/store';
import { createSlice } from '@reduxjs/toolkit';

const initialState: RemitoFormState = {
  data: null,
  status: null,
  actions: null,
  previousState: undefined,
  productos: null,
};

const formSlice = createSlice({
  name: 'remitoForm',
  initialState,
  reducers: {
    resetForm(state) {
      state.data = null;
      state.status = null;
      state.actions = null;
      state.previousState = null;
    },

    setFormStatusBorrador(state) {
      state.status = {
        id: RemitoEstado.Borrador,
        text: RemitoEstado[RemitoEstado.Borrador].toUpperCase(),
        color: colorMapping[RemitoEstado.Borrador],
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        marcarEnviadoRemitoF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar al remito como enviado',
        },
        marcarRecepcionadoRemitoF: {
          visible: false,
          disabled: true,
          tooltip: 'Marcar al remito como recepcionado',
        },
      };

      state.data = {
        clienteId: {
          readOnly: true,
          placeholder: 'Se autocompleta al seleccionar Orden',
        },
        estado: { readOnly: true },
        fechaEmision: { readOnly: false },
        nro: { readOnly: true },
        nroOcCliente: {
          readOnly: true,
          placeholder: 'Se autocompleta al seleccionar Orden',
        },
        nroProveedor: {
          readOnly: true,
          placeholder: 'Se autocompleta al seleccionar Orden',
        },
        ordenId: { readOnly: false },
        transporteId: { readOnly: false },
      };
    },
    setFormStatusEnviado(state) {
      state.status = {
        id: RemitoEstado.Enviado,
        text: RemitoEstado[RemitoEstado.Enviado].toUpperCase(),
        color: colorMapping[RemitoEstado.Enviado],
      };
      state.actions = {
        guardar: {
          visible: false,
          disabled: true,
          tooltip: 'Guardar',
        },

        marcarEnviadoRemitoF: {
          visible: false,
          disabled: true,
          tooltip: 'Marcar al remito como enviado',
        },
        marcarRecepcionadoRemitoF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar al remito como recepcionado',
        },
      };
    },
    setFormStatusRecepcionado(state) {
      state.status = {
        id: RemitoEstado.Recepcionado,
        text: RemitoEstado[RemitoEstado.Recepcionado].toUpperCase(),
        color: colorMapping[RemitoEstado.Recepcionado],
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        marcarEnviadoRemitoF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar al remito como enviado',
        },
        marcarRecepcionadoRemitoF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar al remito como recepcionado',
        },
      };
    },
    setModifyingProducts(state) {
      state.previousState = {
        status: state.status,
        actions: state.actions,
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: true,
          tooltip: 'Guardar',
        },

        marcarEnviadoRemitoF: {
          visible: true,
          disabled: true,
          tooltip: 'Marcar al remito como enviado',
        },
        marcarRecepcionadoRemitoF: {
          visible: true,
          disabled: true,
          tooltip: 'Marcar al remito como recepcionado',
        },
      };
    },
    setModifyingProductsFinished(state) {
      state.status = state.previousState!.status;
      state.actions = state.previousState!.actions;
      state.previousState = null;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(marcarEnviadoRemitoF.fulfilled, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción exitosa.'
      );
    });
    builder.addCase(marcarEnviadoRemitoF.rejected, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción fallida.'
      );
    });

    builder.addCase(marcarRecepcionadoRemitoF.fulfilled, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción exitosa.'
      );
    });
    builder.addCase(marcarRecepcionadoRemitoF.rejected, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción fallida.'
      );
    });
  },
});
// Selectors

export const selectFormStatus = (state: RootState) => state.remito.form.status;

export const selectMarcarEnviadoRemitoF = (state: RootState) =>
  state.remito.form.actions?.marcarEnviadoRemitoF;

export const selectMarcarRecepcionadoRemitoF = (state: RootState) =>
  state.remito.form.actions?.marcarRecepcionadoRemitoF;

export const selectGuardar = (state: RootState) =>
  state.remito.form.actions?.guardar;

// Export actions
export const {
  resetForm,

  setFormStatusBorrador,
  setFormStatusEnviado,
  setFormStatusRecepcionado,
  setModifyingProducts,
  setModifyingProductsFinished,
} = formSlice.actions;

export default formSlice.reducer;
